import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../App';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  return <Link to={`/product/${product.id}`} className="group" data-id="element-94">
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden transition-shadow hover:shadow-md" data-id="element-95">
        <div className="aspect-square overflow-hidden" data-id="element-96">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-97" />
        </div>
        <div className="p-4" data-id="element-98">
          <h3 className="text-gray-800 font-medium text-lg mb-1 group-hover:text-green-600 transition" data-id="element-99">
            {product.name}
          </h3>
          <p className="text-gray-500 text-sm mb-2 capitalize" data-id="element-100">
            {product.subcategory}
          </p>
          <div className="flex items-center justify-between" data-id="element-101">
            <span className="text-green-600 font-semibold" data-id="element-102">
              ${product.price.toLocaleString()}
            </span>
            <span className="bg-green-50 text-green-700 text-xs px-2 py-1 rounded-full" data-id="element-103">
              {product.category === 'electronics' ? 'Electronics' : 'Precious Metal'}
            </span>
          </div>
        </div>
      </div>
    </Link>;
}